import { ApiError, ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const reportHistoryUrl = "/api/v2/report/GetReportHistory";
const downloadReportUrl = "/api/v2/report/DownloadReport";

export interface loadReportsParams extends ApiParameter {
    pageNumber: number;
    isFromDashboard: boolean;
    currentDateTime: string;
}

export interface downloadParam extends ApiParameter {
    jobId: string;
    downloadFileName: string;
}

export interface OrderHistoryResultModel {
    orderHistoryReports: OrderHistoryReport[];
    pagination: Pagination;
}

export interface Pagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: any;
    sortOptions: any;
    sortType: any;
    nextPageUri: string;
    prevPageUri: string;
}

export interface OrderHistoryReport {
    id: string;
    customProperties: any[];
    base64Report: string;
    jobId: string;
    downloadFileName: string;
    createdOn: string;
    createdBy: string;
    modifiedOn: string;
    modifiedBy: string;
}

export const getReportHistory = async (parameter: loadReportsParams) => {
    const response = await get<OrderHistoryResultModel>(reportHistoryUrl, parameter);
    return response;
};

export const downloadReport = async (parameter: downloadParam) => {
    const response = await fetch(`${downloadReportUrl}/${parameter.jobId}`);

    try {
        const blob = response.ok && (await response.blob());
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return blob;
    } catch (error) {
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(`${downloadReportUrl}${parameter.jobId}`, response, message, errorJson);
    }
};
